import React, {Component} from 'react'

export default class Payment extends Component {

    constructor(props) {
        super()
        this.state = {
            payments: props.payments
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            payments: nextProps.payments
        })
    }


    getType = type => {
        if (!type) return
        let formattedType = type
        switch (type) {
            case 'Succeeded':
                formattedType = 'Sikeres'
                break
            case 'Prepared':
                formattedType = 'Előkészítésben'
                break
            case 'Cancelled':
                formattedType = 'Visszavonva'
                break
            case 'Expired':
                formattedType = 'Lejárt'
                break
        }

        return formattedType
    }


    render() {
        if (!this.state.payments.length) {
            return <h1 className='font-size-14'>Nincs megjeleníthető adat.</h1>
        }
        return (
            <section id='used-credits'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <table className='table table-striped  table-aibook-no-border'>
                                <thead>
                                <tr>
                                    <th>Dátum</th>
                                    <th>Összeg</th>
                                    <th>Azonosító</th>
                                    <th>Állapot</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.payments.length ?
                                    this.state.payments.map((item) => {
                                        return <tr key={item.id}>
                                            <td>{item.created_at}</td>
                                            <td>{item.amount} HUF</td>
                                            <td>{item.payment_token}</td>
                                            <td>{this.getType(item.payment_status)}</td>
                                        </tr>
                                    })
                                    : ''}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/history/payment.js